import axios, { Axios } from "axios";
// import { deleteUser } from "firebase/auth";/

const baseurl = "https://mern-music-app-intern-2023.onrender.com/";

export const validateUser = async (token) => {
  try {
    const res = await axios.get(`${baseurl}api/users/login`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return res.data;
  } catch (error) {}
};

export const getAllUsers = async () => {
  try {
    const res = await axios.get(`${baseurl}api/users/getusers`);
    return res.data;
  } catch (error) {
    return null;
  }
};

export const getAllArtists = async () => {
  try {
    const res = await axios.get(`${baseurl}api/artists/getAll`);
    return res.data;
  } catch (error) {
    return null;
  }
};

export const getAllAlbums = async () => {
  try {
    const res = await axios.get(`${baseurl}api/albums/getAll`);
    return res.data;
  } catch (error) {
    return null;
  }
};

export const getAllSongs = async () => {
  try {
    const res = await axios.get(`${baseurl}api/songs/getAll`);
    return res.data;
  } catch (error) {
    return null;
  }
};

export const changingUserRole = async (userId, role) => {
  try {
    const res = Axios.put(`${baseurl}api/users/updateRole/${userId}`, {
      data: { role: role },
    });
    return res;
  } catch (error) {
    return null;
  }
};

export const removeUser = async (userId) => {
  try {
    const res = axios.delete(`${baseurl}api/users/deleteUser/${userId}`);
    return res;
  } catch (error) {
    return null;
  }
};

export const saveNewArtist = async (data) => {
  try {
    const res = axios.post(`${baseurl}api/artists/save`, { ...data });
    return (await res).data.savedArtist;
  } catch (error) {
    return null;
  }
};

export const saveNewAlbum = async (data) => {
  try {
    const res = axios.post(`${baseurl}api/albums/save`, { ...data });
    return (await res).data.savedAlbum;
  } catch (error) {
    return null;
  }
};
export const saveNewSong = async (data) => {
  try {
    const res = axios.post(`${baseurl}api/songs/save`, { ...data });
    return (await res).data.savedSong;
  } catch (error) {
    return null;
  }
};

export const deleteSongById = async (id) => {
  try {
    const res = axios.delete(`${baseurl}api/songs/delete/${id}`);
    return res;
  } catch (error) {
    return null;
  }
};
